module.exports = __webpack_public_path__ + "static/media/client.c439169c.svg";